

/**
 * 修改title的方法。fixed ios 不允许修改title的问题
 * 使用方法：
 * 		import Title from 'c-up-title'
 * 		Title.set('新标题');
 */

var ua = window.navigator.userAgent;
var isIOS = /iPhone|iPad|iPod/i.test(ua);

var Title = {
    /**
     * 修改title
     */
    set: function set(value) {
        this.setTitle(value);

        if (isIOS) {
            this.hackIOSTitle(value);
        }
    },

    setTitle: function setTitle(value) {
        var nodeTitle = $('title').eq(0);

        if (value && value !== '') {
            nodeTitle.html(value);
        }
    },

    hackIOSTitle: function hackIOSTitle(value) {
        var $iframe;

        $iframe = $('<iframe src="http://n.cdn.pengpengla.com/1000401/game/pic/1460535512667.png" style="display:none;border:0;width:0;height:0;"></iframe>');
        $iframe.on('load', function () {
            setTimeout(function () {
                $iframe.off('load').remove();
            }, 300);
        }).appendTo('body');
    }
};

module.exports = Title;


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-title/dist/index.js
// module id = 85
// module chunks = 3 4 5 6 7 8 9 10 11 12 13 14 15 17 18 19 20 21 22 23 24